
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'RatesManagementHeader'
})
export default class extends Vue {
}
